import { render, staticRenderFns } from "./information-from-expert.vue?vue&type=template&id=43ad88e9"
import script from "./information-from-expert.vue?vue&type=script&lang=js"
export * from "./information-from-expert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports